import React, { useEffect } from "react";
import { useHistory } from "react-router";
import { PageLoading } from "../../../../components";
import { Routes } from "../../../../root/routes";

// Stub page that for now just redirects to the first HR data map step (employee collection)

export function HRDataMapRootPage() {
  const history = useHistory();

  useEffect(() => {
    history.push(Routes.hrCenter.hrVendorInventory);
  }, []);

  return <PageLoading />;
}
